import { c as _c } from "react/compiler-runtime";
import { FaroBulkDialog } from "@components/common/faro-table/bulk-dialog/bulk-dialog";
import { BulkSuccessDialog } from "@components/common/faro-table/bulk-dialog/bulk-success-dialog";
import { FaroTextButton } from "@components/common/faro-text-button";
import { useDeleteTeamsBulkDialogContent } from "@components/table/teams/bulk-actions/bulk-delete-teams-helper";
import { useTeamsAccess } from "@hooks/access-control/use-teams-access";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { bulkActionNameSelector, selectedEntitiesSelector, shouldShowSuccessDialogSelector } from "@store/table/table-selector";
import { setBulkActionName, updateOne } from "@store/table/table-slice";
import { deleteTeam } from "@store/teams/teams-slice-thunk";
import { BulkActionEvents } from "@utils/track-event/track-event-list";
import { useEffect, useState } from "react";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";
import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
import { Text, DeleteIcon } from "@flat-ui";

/** Show delete teams button and dispatch action where the bulk dialog will act accordingly */
export function BulkDeleteTeams(t0) {
  const $ = _c(34);
  const {
    companyId
  } = t0;
  const [shouldShowDialog, setShouldShowDialog] = useState(false);
  const bulkActionName = useAppSelector(bulkActionNameSelector);
  const shouldShowSuccessDialog = useAppSelector(shouldShowSuccessDialogSelector);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = selectedEntitiesSelector("teams");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedEntities = useAppSelector(t1);
  const {
    canDeleteTeams
  } = useTeamsAccess();
  const dispatch = useAppDispatch();
  const {
    bulkDialogContent,
    successDialogContent
  } = useDeleteTeamsBulkDialogContent();
  const mode = useBulkActionsMode();
  let t2;
  let t3;
  if ($[1] !== shouldShowSuccessDialog) {
    t2 = () => {
      if (shouldShowSuccessDialog) {
        setShouldShowDialog(false);
      }
    };
    t3 = [shouldShowSuccessDialog];
    $[1] = shouldShowSuccessDialog;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== canDeleteTeams || $[5] !== dispatch || $[6] !== selectedEntities) {
    t4 = function onDeleteTeamClick() {
      dispatch(setBulkActionName("removeTeam"));
      for (const entity of selectedEntities) {
        if (!canDeleteTeams) {
          dispatch(updateOne({
            id: entity.id,
            changes: {
              status: "not-allowed",
              message: `You are not allowed to delete this ${TEAM_DISPLAY_NAME} from workspace`
            }
          }));
        }
      }
      setShouldShowDialog(true);
    };
    $[4] = canDeleteTeams;
    $[5] = dispatch;
    $[6] = selectedEntities;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onDeleteTeamClick = t4;
  let t5;
  if ($[8] !== mode) {
    t5 = getBulkActionButtonConfig(mode, `Remove ${TEAM_DISPLAY_NAME} from workspace`);
    $[8] = mode;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const config = t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DeleteIcon sx={{
      width: "18px",
      height: "18px"
    }} />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== config.shouldShowText) {
    t7 = config.shouldShowText && <Text variant="buttonM">Remove</Text>;
    $[11] = config.shouldShowText;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== config.rippleColor || $[14] !== config.sx || $[15] !== config.tooltipText || $[16] !== onDeleteTeamClick || $[17] !== t7) {
    t8 = <FaroTextButton onClick={onDeleteTeamClick} tooltipText={config.tooltipText} sx={config.sx} rippleColor={config.rippleColor} startIcon={t6}>{t7}</FaroTextButton>;
    $[13] = config.rippleColor;
    $[14] = config.sx;
    $[15] = config.tooltipText;
    $[16] = onDeleteTeamClick;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== bulkActionName || $[20] !== shouldShowSuccessDialog || $[21] !== successDialogContent) {
    t9 = bulkActionName === "removeTeam" && shouldShowSuccessDialog && <BulkSuccessDialog dialogContent={successDialogContent} />;
    $[19] = bulkActionName;
    $[20] = shouldShowSuccessDialog;
    $[21] = successDialogContent;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== bulkActionName || $[24] !== bulkDialogContent || $[25] !== companyId || $[26] !== dispatch || $[27] !== selectedEntities || $[28] !== shouldShowDialog) {
    t10 = bulkActionName === "removeTeam" && shouldShowDialog && <FaroBulkDialog dialogContent={bulkDialogContent} onClose={() => setShouldShowDialog(false)} trackingEvent={BulkActionEvents.bulkDeleteTeam} bulkActionCallback={team => dispatch(deleteTeam({
      companyId,
      teamId: team.id
    })).unwrap()} selectedEntities={selectedEntities} uniqueIdKey="id" tableDataType="teams" />;
    $[23] = bulkActionName;
    $[24] = bulkDialogContent;
    $[25] = companyId;
    $[26] = dispatch;
    $[27] = selectedEntities;
    $[28] = shouldShowDialog;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t8 || $[32] !== t9) {
    t11 = <>{t8}{t9}{t10}</>;
    $[30] = t10;
    $[31] = t8;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
}